import { useMemo } from 'react';

import { usePetitionDetailsPageData } from 'src/app/pages/petitionGamma/details/pageContext';

type Result = ModelHookResult<{
	isShown: boolean;
	percentage: number;
	minPercentage: number;
}>;

export const useVotersPercentage = (): Result => {
	const {
		data: {
			petition: { registeredVoters },
		},
	} = usePetitionDetailsPageData();

	const voters = useMemo(() => {
		const { percentage, minPercentage } = registeredVoters ?? {};

		return {
			data: {
				isShown: !!percentage && !!minPercentage && percentage >= minPercentage,
				percentage: percentage ?? 0,
				minPercentage: minPercentage ?? 0,
			},
		};
	}, [registeredVoters]);

	return voters;
};
